// extracted by mini-css-extract-plugin
export var divider = "_x4-0";